// WARNING: This file is auto-generated. Do not modify.
import React, { SVGProps } from 'react';

const CardBlock = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 100 60" {...props}>
    <path
      fill="none"
      stroke="currentColor"
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d="M31.05 13.24h37.9v33.52h-37.9z"
    />
    <path
      fill="none"
      stroke="currentColor"
      strokeMiterlimit={10}
      strokeWidth={3}
      d="M35.15 27.86h27.2"
    />
    <path
      fill="none"
      stroke="currentColor"
      strokeMiterlimit={10}
      d="M35.15 33.16h24.3M35.15 36.56h27.2M35.15 39.96h24.3"
    />
  </svg>
);

export default CardBlock;
